/* lib/api/gifts.js — подарочные сертификаты.
 * Контракт как у всех доменных модулей: apiFetch возвращает {ok,status,data},
 * исключений по HTTP не бросает — проверяет вызывающий.
 *
 * X-Workspace-Id тут НАМЕРЕННО не передаётся ни в одном методе. Подарок не
 * принадлежит пространству: даритель покупает его собой (платёж якорится на
 * личное ws на сервере), а получатель — вообще посторонний человек, у которого
 * активным может быть любое пространство или никакое. Прокинув сюда активное
 * ws, мы бы привязали кабинет подарков к тому, что случайно выбрано в шапке. */

import { apiFetch } from './client.js';

/** Что можно подарить: только публичные платные тарифы (фильтр на сервере). */
export const listGiftPlans = () => apiFetch('/api/subscription/gift/plans/');

/** Оплата подарка картой. method: 'card' | 'foreign_card'. */
export const startGiftCheckout = (body) =>
  apiFetch('/api/subscription/gift/checkout/', { method: 'POST', body });

/** Оплата подарка счётом на юрлицо (Точка). */
export const startGiftInvoice = (body) =>
  apiFetch('/api/subscription/gift/invoice/', { method: 'POST', body });

/** Кабинет дарителя: купленные им сертификаты. */
export const listMyGifts = () => apiFetch('/api/subscription/gift/');

/** Правка получателя/даты — пока письмо не ушло и код не активирован. */
export const updateGift = (id, body) =>
  apiFetch(`/api/subscription/gift/${id}/`, { method: 'PATCH', body });

/** Отправить письмо немедленно, не дожидаясь расписания. */
export const sendGiftNow = (id) =>
  apiFetch(`/api/subscription/gift/${id}/send/`, { method: 'POST', body: {} });

/** Превью активации: что именно даст код ЭТОМУ пользователю. */
export const previewGift = (code) =>
  apiFetch(`/api/subscription/gift/redeem/?code=${encodeURIComponent(code)}`);

/** Активация. target: 'auto' | 'new' | 'existing'. */
export const redeemGift = (body) =>
  apiFetch('/api/subscription/gift/redeem/', { method: 'POST', body });

/** Адрес PDF — качается через downloadFile(), а не голым <a href>. */
export const giftPdfUrl = (id) => `/api/subscription/gift/${id}/pdf/`;
